export default __webpack_public_path__ + "static/media/icon~NTcFjzip.af95425a.svg";